import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedCommonModule } from '../../shared/shared-common.module';
// import { AffiliateModule } from '../affiliate/affiliate.module';

// Messenger Core
import { MessengerComponent } from '../../shared/partials/messenger/messenger.component';
import { MessengerChatBoxComponent } from '../../shared/partials/messenger/messenger-chat-box/messenger-chat-box.component';
import { MessengerChatPopupComponent } from '../../shared/partials/messenger/messenger-chat-popup/messenger-chat-popup.component';
import { MessengerThreadItemComponent } from '../../shared/partials/messenger/messenger-thread-item/messenger-thread-item.component';
import { MessengerSelectAffiliateToChatComponent } from '../../shared/partials/messenger/messenger-select-affiliate-to-chat/messenger-select-affiliate-to-chat.component';

// Messenger UI Components
import { MessengerChatLabelComponent } from '../../shared/partials/messenger/messenger-ui-pack/messenger-chat-label/messenger-chat-label.component';
import { MessengerChatImageComponent } from '../../shared/partials/messenger/messenger-ui-pack/messenger-chat-image/messenger-chat-image.component';
import { MessengerChatUserMessageComponent } from '../../shared/partials/messenger/messenger-ui-pack/messenger-chat-user-message/messenger-chat-user-message.component';

// Attachments
import { AttachmentComponentComponent } from '../../shared/partials/messenger/attachment-component/attachment-component.component';
import { AttachmentFileViewComponent } from '../../shared/partials/messenger/attachment-file-view/attachment-file-view.component';

// Thread Management
import { ThreadUsersPopupComponent } from '../../shared/partials/messenger/thread-users-list-popup/thread-users-list-popup.component';
import { ChatUserItemComponent } from '../../shared/partials/messenger/thread-users-list-popup/chat-user-item/chat-user-item.component';

// Messages
import { OwnerMessagesListComponent } from '../../shared/layout/top-menu/fast-actions-buttons/owner-messages-list/owner-messages-list.component';
import { OwnerMessagesElementComponent } from '../../shared/layout/top-menu/fast-actions-buttons/owner-messages-list/owner-messages-element/owner-messages-element.component';
import { MessageToastComponent } from '../../shared/services/message-toast/message-toast.component';

// Announcements
import { AnnouncementComponent } from '../../shared/partials/announcement/announcement.component';
import { AnnouncementToastComponent } from '../../shared/services/announcement-toast/announcement-toast.component';

const MESSENGER_COMPONENTS = [
  // Core Messenger
  MessengerComponent,
  MessengerChatBoxComponent,
  MessengerChatPopupComponent,
  MessengerThreadItemComponent,
  MessengerSelectAffiliateToChatComponent,

  // UI Components
  MessengerChatLabelComponent,
  MessengerChatImageComponent,
  MessengerChatUserMessageComponent,

  // Attachments
  AttachmentComponentComponent,
  AttachmentFileViewComponent,

  // Thread Management
  ThreadUsersPopupComponent,
  ChatUserItemComponent,

  // Messages
  OwnerMessagesListComponent,
  OwnerMessagesElementComponent,
  MessageToastComponent,

  // Announcements
  AnnouncementComponent,
  AnnouncementToastComponent,
];

/**
 * MessengerModule
 *
 * Purpose: Contains all messaging and announcement components:
 * - Real-time chat and messaging
 * - Thread management
 * - File attachments
 * - Announcement system
 * - Message notifications and toasts
 */
@NgModule({
  declarations: MESSENGER_COMPONENTS,
  imports: [
    SharedCommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    // AffiliateModule,
  ],
  exports: MESSENGER_COMPONENTS,
})
export class MessengerModule {}
